import { combineReducersPartial } from "../../store/reducer-factory";
import { MappingState } from "./state";
import {
    getAdUnitAndFormatInfoRequest,
    getDevicesRequest,
    getInterestsRequest,
    getAgeRequest,
    getGenderRequest,
    getLanguagesRequest,
    getTimezonesRequest,
    getCurrenciesRequest,
    getIndustriesRequest,
    getCategoriesRequest,
    getRestrictionsRequest,
    getKPIRequest
} from "@common";
import { FetchingState } from "rd-redux-http";

export const mappingsReducer = combineReducersPartial<MappingState>(
    {
        adunits: getAdUnitAndFormatInfoRequest.reducer,
        devices: getDevicesRequest.reducer,
        interests: getInterestsRequest.reducer,
        age: getAgeRequest.reducer,
        gender: getGenderRequest.reducer,
        languages: getLanguagesRequest.reducer,
        currencies: getCurrenciesRequest.reducer,
        timezones: getTimezonesRequest.reducer,
        industries: getIndustriesRequest.reducer,
        categories: getCategoriesRequest.reducer,
        restrictions: getRestrictionsRequest.reducer,
        kpi: getKPIRequest.reducer
    },
    {
        adunits: { fetchState: FetchingState.INITIAL },
        devices: { fetchState: FetchingState.INITIAL },
        interests: { fetchState: FetchingState.INITIAL },
        age: { fetchState: FetchingState.INITIAL },
        gender: { fetchState: FetchingState.INITIAL },
        languages: { fetchState: FetchingState.INITIAL },
        currencies: { fetchState: FetchingState.INITIAL },
        timezones: { fetchState: FetchingState.INITIAL },
        industries: { fetchState: FetchingState.INITIAL },
        categories: { fetchState: FetchingState.INITIAL },
        restrictions: { fetchState: FetchingState.INITIAL },
        kpi: { fetchState: FetchingState.INITIAL }
    }
);
